"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableReducer = exports.searchReducer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("./constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var searchReducer = function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    specialtyValues: ['Dental/Orthodontics', 'Fertility', 'Hair Restoration', 'Weight Loss Surgery'],
    specialtyText: 'Select a specialty',
    mandatoryFields: ['specialty', 'location', 'name'],
    specialty: '',
    specialtyTabIndex: 2,
    specialtyOpen: false,
    location: '',
    name: '',
    stateSynced: true
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _constants.UPDATE_SEARCH_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        specialty: action.payload.specialty,
        location: action.payload.location,
        name: action.payload.name,
        stateSynced: false
      });
    case _constants.UPDATE_SPECIALTY_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        specialtyOpen: action.payload.specialtyOpen
      });
    case _constants.UPDATE_SYNCED_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        stateSynced: action.payload.stateSynced
      });
    default:
      return state;
  }
};
exports.searchReducer = searchReducer;
var tableReducer = function tableReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    request: 'INITIAL',
    feedback: false,
    resultType: '',
    pageNumber: -1,
    totalResultsFromExactSearch: 0,
    records: [],
    searchQuery: {},
    recordsMap: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _constants.UPDATE_TABLE_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        records: action.payload.records,
        recordsMap: action.payload.recordsMap,
        request: action.payload.request,
        searchQuery: action.payload.searchQuery,
        totalResultsFromExactSearch: action.payload.totalResultsFromExactSearch,
        pageNumber: action.payload.pageNumber,
        feedback: action.payload.feedback,
        resultType: action.payload.resultType
      });
    case _constants.UPDATE_FEEDBACK_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        feedback: action.payload.feedback
      });
    default:
      return state;
  }
};
exports.tableReducer = tableReducer;
